<template>
  <div class="pageOverflow">
    <div class="pageFlex">
      <div class="block" style="border-bottom: 0;">
        <el-input v-model.trim="searchVal" class="width_200" placeholder="请输入手机/姓名/订单号" @keyup.enter.native="search(1)">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="search(1)"></i>
        </el-input>
        <el-date-picker v-model="chooseTime" class="ml_20" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :editable="false">
        </el-date-picker>
        <el-button class="ml_20" type="primary" @click="exportList">导出Excel</el-button>
      </div>
      <div class="businessInfo">
        <ul>
          <li>
            <div class="li_left">
              <h1>{{ listInfo.buyCount }}</h1>
              <h2>售出：累计数量</h2>
            </div>
            <div class="li_right">
              <h1>{{ listInfo.buyTotal }}</h1>
              <h2>售出：累计金额</h2>
            </div>
          </li>
          <li>
            <div class="li_left">
              <h1>{{ listInfo.renewCount }}</h1>
              <h2>续费：累计数量</h2>
            </div>
            <div class="li_right">
              <h1>{{ listInfo.renewTotal }}</h1>
              <h2>续费：累计金额</h2>
            </div>
          </li>
          <li>
            <h1>{{ listInfo.useCount }}</h1>
            <h2>划扣：累计数量</h2>
          </li>
        </ul>
      </div>
      <div class="commonTable">
        <el-table :data="businessTable" tooltip-effect="light">
          <el-table-column prop="createTimeStr" label="时间" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="orderCode" label="订单号" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="mainName" label="操作店铺" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="类型" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.type == 0 ? '售出' : scope.row.type == 1 ? '划扣' : '续费' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="vipCardName" label="套餐名称" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="金额/扣除项目" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">
                <samp v-for="(item,index) in scope.row.vipCardOrderItemList" :key="index">{{ item.dictItemName }}x{{ item.count }}{{ scope.row.vipCardOrderItemList.length == index ? '' : '、' }}</samp>
              </span>
              <span v-else>{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column label="支付方式" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.payType == 1 ? '现金支付' : scope.row.payType == 7 ? '个人微信' : scope.row.payType == 8 ? '个人支付宝' : scope.row.payType == 2 ? '银行卡支付' : scope.row.payType == 4 ? '扫码支付' : scope.row.payType == 3 ? '会员卡支付' : '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="clientName" label="用户姓名" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.clientName ? scope.row.clientName : '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="联系电话" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.phone ? scope.row.phone : '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="technicianName" label="办理员工" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.technicianName ? scope.row.technicianName : '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <yz-btn type="primary" @click="printOrder(scope.row.id,scope.row.type,1)">打印小票</yz-btn>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="businessTable.length > 0" class="blockThree">
        <el-pagination background :current-page.sync="pageNum" :page-size="10" layout="prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getVipCardOrderTotal, getVipCardOrderList, printOrder } from '../../api/index.js';

export default {
  data() {
    return {
      searchVal: '', // 业务记录搜索值
      chooseTime: '', // 选择日期范围
      businessTable: [], // 业务记录列表
      pageNum: 1, // 当前页
      rowCount: 0, // 列表总条数
      listInfo: {
        buyCount: '', // 售出累计数量
        buyTotal: '', // 售出累计金额
        renewCount: '', // 续费累计数量
        renewTotal: '', // 续费累计金额
        useCount: '', // 划扣累计数量
      }
    };
  },
  watch: {
    chooseTime() {
      this.search();
    }
  },
  activated() {
    this.getListInfo();
    this.search();
  },
  methods: {
    // 导出业务记录Excel
    exportList() {
      window.location.href = `${this.Lib.A()}/erp/lookVipCard/exportVipCardOrderList?mainId=${window.sessionStorage.mainId}&startDate=${this.chooseTime[0] ? this.chooseTime[0] : ''}&endDate=${this.chooseTime[1] ? this.chooseTime[1] : ''}&search=${this.searchVal}`;
    },
    // 搜索业务记录
    search(val) {
      this.Lib.keyboardBlur();
      if (val) {
        this.pageNum = val * 1;
      } else {
        this.pageNum = 1;
      }
      const data = {
        pageNum: this.pageNum,
        mainId: window.sessionStorage.mainId,
        startDate: this.chooseTime ? this.chooseTime[0] : '',
        endDate: this.chooseTime ? this.chooseTime[1] : '',
        search: this.searchVal
      };
      getVipCardOrderList(data).then((res) => {
        this.businessTable = res.data.records;
        this.rowCount = res.data.total;
      });
    },
    handleSizeChange(val) {
      this.search(val);
    },
    handleCurrentChange(val) {
      this.search(val);
    },
    getListInfo() {
      const data = {
        mainId: window.sessionStorage.mainId,
        startDate: this.chooseTime ? this.chooseTime[0] : '',
        endDate: this.chooseTime ? this.chooseTime[1] : '',
        search: this.searchVal
      };
      getVipCardOrderTotal(data).then((res) => {
        if (res.code == 0) {
          this.listInfo = res.data;
        } else {
          // console.log(res)
        }
      });
    },
    // 打印
    printOrder(id, type, num) {
      this.$confirm('是否确定打印该小票?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const data = {
          orderId: id,
          mainId: window.sessionStorage.mainId,
          printType: type == 1 ? 3 : 2, // 1：服务订单，2:快捷收银订单，3：美容套餐购买/充值，4：美容套餐划扣
          isManual: num ? 1 : 0
        };
        printOrder(data).then(() => {

        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.businessInfo {
  width: 100%;
  ul {
    margin: 5px 0 20px 0;
    list-style: none;
    li {
      width: 33%;
      float: left;
      background-color: #f9f9f9;
      height: 100px;
      text-align: center;
      .li_left {
        width: 50%;
        float: left;
      }
      .li_right {
        width: 50%;
        float: right;
      }
      h1 {
        width: 100%;
        height: 50px;
        line-height: 72px;
        font-size: 25px;
        color: #409eff;
        font-weight: 600;
      }
      h2 {
        height: 50px;
        font-size: 15px;
        line-height: 36px;
        color: #333333;
        font-weight: 500;
      }
    }
    li:nth-child(3n + 2) {
      margin-left: 0.5%;
      margin-right: 0.5%;
    }
  }
  ul:after {
    content: "";
    display: table;
    clear: both;
  }
}
</style>
